import { CampaignAdgroupSelectorView } from '@bingads-webui-campaign-react/campaign-adgroup-selector';
import _ from 'underscore';
import { getAdgroupData } from './adgroup-selector-repository';
import { getCampaignData } from './campaign-selector-repository';

const CAMPAIGN_PAGESIZE = 10;
const ADGROUP_PAGESIZE = 6;

export class CampaignAdgroupSelectorProxy {
  constructor({
    onCampaignSelect,
    onAdGroupSelect,
    jsData,
    edmCampaign,
    withUiBlocker,
    i18n,
    getCustomizedCampaignData,
    getCustomizedAdGroupData,
    selectedCampaign,
    selectedAdGroup,
    isMultiMode,
    onMultiSelectedDone,
    optionalCampaignFilter,
    optionalAdgroupFilter,
    optionalCampaignSelect,
    optionalAdGroupSelect,
    optionalAdGroupExpand,
  }) {
    this.onCampaignSelect = onCampaignSelect;
    this.onAdGroupSelect = onAdGroupSelect;
    this.getCustomizedCampaignData = getCustomizedCampaignData || null;
    this.getCustomizedAdGroupData = getCustomizedAdGroupData || null;
    this.jsData = jsData;
    this.edmCampaign = edmCampaign;
    this.withUiBlocker = withUiBlocker;
    this.i18n = i18n;
    this.selectedCampaign = selectedCampaign;
    this.selectedAdGroup = selectedAdGroup;
    this.isMultiMode = isMultiMode;
    this.onMultiSelectedDone = onMultiSelectedDone;
    this.optionalCampaignFilter = optionalCampaignFilter;
    this.optionalAdgroupFilter = optionalAdgroupFilter;
    this.optionalCampaignSelect = optionalCampaignSelect;
    this.optionalAdGroupSelect = optionalAdGroupSelect;
    this.optionalAdGroupExpand = optionalAdGroupExpand;
  }

  fecthCampaignData({
    query = '',
    pageNumber = 0,
    pageSize = CAMPAIGN_PAGESIZE,
    campaignAdgroupSelectorView,
    optionalCampaignFilter = this.optionalCampaignFilter,
  }) {
    const uiBlockContainer = campaignAdgroupSelectorView && campaignAdgroupSelectorView.$('.dropdown-menu');

    if (this.getCustomizedCampaignData === null) {
      return getCampaignData({
        query,
        pageNumber,
        pageSize,
        optionalCampaignFilter,
        optionalCampaignSelect: this.optionalCampaignSelect,
        optionalAdGroupExpand: this.optionalAdGroupExpand,
      }, this.jsData).finally(this.withUiBlocker(uiBlockContainer));
    }

    return this.getCustomizedCampaignData({
      query,
      pageNumber,
      pageSize,
    }, this.jsData).finally(this.withUiBlocker(uiBlockContainer));
  }

  fecthAdgroupData({
    query = '',
    pageNumber = 0,
    pageSize = ADGROUP_PAGESIZE,
    campaignAdgroupSelectorView,
    scopeParentItem,
    optionalAdgroupFilter = this.optionalAdgroupFilter,
  }) {
    const uiBlockContainer = campaignAdgroupSelectorView && campaignAdgroupSelectorView.$('.dropdown-menu');
    const campaignId = scopeParentItem && scopeParentItem.Id;

    if (this.getCustomizedAdGroupData === null) {
      return getAdgroupData({
        query,
        pageNumber,
        pageSize,
        campaignId,
        optionalAdgroupFilter,
        optionalAdGroupSelect: this.optionalAdGroupSelect,
        optionalAdGroupExpand: this.optionalAdGroupExpand,
      }, this.jsData, this.edmCampaign).finally(this.withUiBlocker(uiBlockContainer));
    }

    return this.getCustomizedAdGroupData({
      query,
      pageNumber,
      pageSize,
      campaignId,
    }, this.jsData, this.edmCampaign).finally(this.withUiBlocker(uiBlockContainer));
  }

  getCampaignAdgroupSelectorView() {
    const checkSelected = (selectedItem, item) => selectedItem && selectedItem.Id === item.Id;
    const campaignAdgroupSelectorView = new CampaignAdgroupSelectorView({
      campaign: {
        pageSize: CAMPAIGN_PAGESIZE,
        onFetch: args => this.fecthCampaignData({ ...args, campaignAdgroupSelectorView }),
        checkSelected,
      },
      adgroup: {
        pageSize: ADGROUP_PAGESIZE,
        onFetch: args => this.fecthAdgroupData({ ...args, campaignAdgroupSelectorView }),
        checkSelected,
      },
      i18n: this.i18n,
      selectedCampaign: this.selectedCampaign,
      selectedAdGroup: this.selectedAdGroup,
      isMultiMode: this.isMultiMode,
    });

    campaignAdgroupSelectorView.on('selected-campaign', (selectedItem) => {
      this.onCampaignSelect(selectedItem);
    });

    campaignAdgroupSelectorView.on('selected-adgroup', (selectedItem) => {
      this.onAdGroupSelect(selectedItem);
    });

    campaignAdgroupSelectorView.on('selected-adgroup-list', (selectedList) => {
      if (_.isFunction(this.onMultiSelectedDone)) {
        this.onMultiSelectedDone(selectedList);
      }
    });

    return campaignAdgroupSelectorView;
  }
}

